import { signOut as firebaseSignOut } from 'firebase/auth';

import { queryClient } from 'configs/queryClient';
import { auth } from 'lib/firebase';
import { stopActivePubnubClient } from 'lib/activePubnubClient';
import { unsubscribeFromWebPush } from 'lib/webPush';
import useMessageStore from 'store/useMessageStore';

/** Firebase のサインアウトに失敗した場合はそのエラーを持つ（後片付けは済んでいる） */
export type SignOutResult = { ok: true } | { ok: false; error: unknown };

/**
 * 全てのセッション状態を破棄してログアウトする。
 * 順序: Web Push 解除 → キャッシュ/Zustand/PubNub 破棄 → Firebase sign-out → キャッシュ再破棄。
 * @param expectedAuthUid 指定すると、その利用者のトークンでだけ Web Push の削除を依頼する
 */
export async function signOutCompletely(
  expectedAuthUid?: string,
): Promise<SignOutResult> {
  try {
    await unsubscribeFromWebPush(expectedAuthUid);
  } catch {
    // 解除失敗はログアウトを妨げない（ブラウザ側失敗は pending 記録で次回起動時に再試行）
  }

  queryClient.clear();
  useMessageStore.getState().resetStore();
  stopActivePubnubClient();

  let result: SignOutResult = { ok: true };
  try {
    if (auth.currentUser) {
      await firebaseSignOut(auth);
    }
  } catch (error) {
    result = { ok: false, error };
  }

  // sign-out を待っている間に解決したクエリが前アカウントのデータを入れ直すため、
  // 認証状態が確定した後に cache をもう一度空にする
  queryClient.clear();
  return result;
}
